var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{class:_vm.labelCSS},[_vm._v(" "+_vm._s(_vm.labelString)+" "),(_vm.requiredButEmpty)?_c('span',{staticClass:"text-red-500 py-2 rounded"},[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }